import { ErrorBoundary } from '@sentry/react'
import { forwardRef } from 'react'

import SentryFallback from './SentryFallback'

/**
 * Higher-order component that wraps a component with Sentry's ErrorBoundary.
 *
 * @template P
 * @param {import('react').ComponentType<P>} WrappedComponent - The component to wrap.
 * @returns {import('react').ForwardRefExoticComponent<import('react').PropsWithoutRef<P> & import('react').RefAttributes<unknown>>}
 */
const withSentryWrapper = (WrappedComponent) => {
    // eslint-disable-next-line react/display-name
    return forwardRef((props, ref) => (
        <ErrorBoundary fallback={<SentryFallback />}>
            <WrappedComponent ref={ref} {...props} />
        </ErrorBoundary>
    ))
}

export default withSentryWrapper
